import React from "react";
import useStyle from "./Header.styles";

const Header = (props) => {
  const styles = useStyle();
  return <header className={styles.header} style={{ background: `url(${props.bg}) top left`, backgroundSize: "cover" }}>{props.children}</header>;
};

export default Header;
